import { render, staticRenderFns } from "./Feedbar.vue?vue&type=template&id=38a3e09e&scoped=true&"
import script from "./Feedbar.vue?vue&type=script&lang=js&"
export * from "./Feedbar.vue?vue&type=script&lang=js&"
import style0 from "./Feedbar.vue?vue&type=style&index=0&id=38a3e09e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3e09e",
  null
  
)

export default component.exports